import { motion } from 'framer-motion';

export const Preloader = () => {
  return (
    <div className="preloader">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, repeat: Infinity, repeatType: 'reverse' }}
        className="text-center"
      >
        {/* <div className="w-24 h-24 mx-auto mb-4 rounded-sm border-2 border-brand-pearl flex items-center justify-center">
          <span className="text-4xl font-heading font-bold text-brand-pearl">R</span>
        </div> */}
        <img
  src="logos/rudralogo.png"
  alt="Rudra Apparel"
  className="h-20 w-auto mx-auto mb-4 object-contain"
/>
        <p className="text-brand-walnut font-mono text-xs tracking-widest uppercase">Loading</p>
      </motion.div>
    </div>
  );
};